
import { computed, defineComponent, inject, ref } from 'vue';
import { BRAND_PURPLE, ISignupFormState, normalizeRoomCode, VALID_ROOM_CODE } from '../signupFlow';
import { ISignupService } from '../signupService';
import { PhArrowLeft, PhArrowRight } from '@phosphor-icons/vue';

export default defineComponent({
    name: 'StepConnectRoom',
    components: { PhArrowLeft, PhArrowRight },
    emits: ['connect', 'back'],
    setup(props, { emit }) {
        const form = inject('signupForm') as ISignupFormState;
        const service = inject('signupService') as ISignupService;
        const connecting = ref(false);

        // Room code lives on the shared form so it survives navigation between
        // use-ditto, connect-room, and share-method (mirrors the proto's lifted state).
        const roomCodeInput = computed({
            get: () => form.roomCode,
            set: (value: string) => {
                form.roomCode = value.toUpperCase();
            }
        });

        const isValidCode = computed(() => normalizeRoomCode(form.roomCode) === VALID_ROOM_CODE);

        async function handleConnect() {
            if (!form.roomCode.trim() || connecting.value) return;
            connecting.value = true;
            await service.checkRoomCode(form.roomCode);
            connecting.value = false;
            emit('connect');
        }

        return { form, roomCodeInput, isValidCode, connecting, handleConnect, brandPurple: BRAND_PURPLE };
    }
});
